/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AuditIndexRouteImport } from './routes/audit/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as BusinessEnvironmentFactorsIndexRouteImport } from './routes/business-environment-factors/index'
import { Route as BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteImport } from './routes/business-environment-factors/$businessEnvironmentFactorId'
import { Route as BusinessEnvironmentFactorsNewRouteImport } from './routes/business-environment-factors/new'
import { Route as BusinessObjectivesIndexRouteImport } from './routes/business-objectives/index'
import { Route as BusinessObjectivesBusinessObjectiveIdRouteImport } from './routes/business-objectives/$businessObjectiveId'
import { Route as BusinessObjectivesNewRouteImport } from './routes/business-objectives/new'
import { Route as BusinessProcessesIndexRouteImport } from './routes/business-processes/index'
import { Route as BusinessProcessesBusinessProcessIdRouteImport } from './routes/business-processes/$businessProcessId'
import { Route as BusinessProcessesNewRouteImport } from './routes/business-processes/new'
import { Route as BusinessUnitsIndexRouteImport } from './routes/business-units/index'
import { Route as BusinessUnitsBusinessUnitIdRouteImport } from './routes/business-units/$businessUnitId'
import { Route as BusinessUnitsNewRouteImport } from './routes/business-units/new'
import { Route as CapabilitiesIndexRouteImport } from './routes/capabilities/index'
import { Route as CapabilitiesCapabilityIdRouteImport } from './routes/capabilities/$capabilityId'
import { Route as CapabilitiesNewRouteImport } from './routes/capabilities/new'
import { Route as InformationIndexRouteImport } from './routes/information/index'
import { Route as InformationDataDomainIdRouteImport } from './routes/information/$dataDomainId'
import { Route as InformationNewRouteImport } from './routes/information/new'
import { Route as PhysicalProcessesIndexRouteImport } from './routes/physical-processes/index'
import { Route as PhysicalProcessesPhysicalProcessIdRouteImport } from './routes/physical-processes/$physicalProcessId'
import { Route as PhysicalProcessesNewRouteImport } from './routes/physical-processes/new'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesServiceIdRouteImport } from './routes/services/$serviceId'
import { Route as ServicesNewRouteImport } from './routes/services/new'
import { Route as StakeholdersIndexRouteImport } from './routes/stakeholders/index'
import { Route as StakeholdersStakeholderIdRouteImport } from './routes/stakeholders/$stakeholderId'
import { Route as StakeholdersNewRouteImport } from './routes/stakeholders/new'
import { Route as SuppliersIndexRouteImport } from './routes/suppliers/index'
import { Route as SuppliersNewRouteImport } from './routes/suppliers/new'
import { Route as TagsIndexRouteImport } from './routes/tags/index'
import { Route as TagsNewRouteImport } from './routes/tags/new'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'
import { Route as TeamsIndexRouteImport } from './routes/teams/index'
import { Route as TeamsTeamIdRouteImport } from './routes/teams/$teamId'
import { Route as TeamsNewRouteImport } from './routes/teams/new'
import { Route as TechnologiesIndexRouteImport } from './routes/technologies/index'
import { Route as TechnologiesTechnologyIdRouteImport } from './routes/technologies/$technologyId'
import { Route as TechnologiesNewRouteImport } from './routes/technologies/new'
import { Route as TechnologyCapabilitiesIndexRouteImport } from './routes/technology-capabilities/index'
import { Route as TechnologyCapabilitiesTechnologyCapabilityIdRouteImport } from './routes/technology-capabilities/$technologyCapabilityId'
import { Route as TechnologyCapabilitiesNewRouteImport } from './routes/technology-capabilities/new'
import { Route as TechnologyDomainsIndexRouteImport } from './routes/technology-domains/index'
import { Route as TechnologyDomainsTechnologyDomainIdRouteImport } from './routes/technology-domains/$technologyDomainId'
import { Route as TechnologyDomainsNewRouteImport } from './routes/technology-domains/new'
import { Route as TechnologyFamiliesIndexRouteImport } from './routes/technology-families/index'
import { Route as TechnologyFamiliesNewRouteImport } from './routes/technology-families/new'
import { Route as AdminBulkOperationsIndexRouteImport } from './routes/admin/bulk-operations/index'
import { Route as AdminModelPackageIndexRouteImport } from './routes/admin/model-package/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRouteImport } from './routes/business-environment-factors/$businessEnvironmentFactorId.edit'
import { Route as BusinessObjectivesBusinessObjectiveIdEditRouteImport } from './routes/business-objectives/$businessObjectiveId.edit'
import { Route as BusinessProcessesBusinessProcessIdEditRouteImport } from './routes/business-processes/$businessProcessId.edit'
import { Route as BusinessUnitsBusinessUnitIdEditRouteImport } from './routes/business-units/$businessUnitId.edit'
import { Route as CapabilitiesCapabilityIdEditRouteImport } from './routes/capabilities/$capabilityId.edit'
import { Route as InformationDataDomainIdEditRouteImport } from './routes/information/$dataDomainId.edit'
import { Route as MaturityComparisonIndexRouteImport } from './routes/maturity/comparison/index'
import { Route as MaturityFrameworksIndexRouteImport } from './routes/maturity/frameworks/index'
import { Route as MaturityFrameworksFrameworkIdRouteImport } from './routes/maturity/frameworks/$frameworkId'
import { Route as MaturityFrameworksNewRouteImport } from './routes/maturity/frameworks/new'
import { Route as PhysicalProcessesPhysicalProcessIdEditRouteImport } from './routes/physical-processes/$physicalProcessId.edit'
import { Route as ProjectsProjectIdEditRouteImport } from './routes/projects/$projectId.edit'
import { Route as ServicesServiceIdAssessmentsRouteImport } from './routes/services/$serviceId.assessments'
import { Route as ServicesServiceIdDependenciesRouteImport } from './routes/services/$serviceId.dependencies'
import { Route as ServicesServiceIdDiagramsRouteImport } from './routes/services/$serviceId.diagrams'
import { Route as ServicesServiceIdEditRouteImport } from './routes/services/$serviceId.edit'
import { Route as ServicesServiceIdImpactRouteImport } from './routes/services/$serviceId.impact'
import { Route as SettingsApiDocsIndexRouteImport } from './routes/settings/api-docs/index'
import { Route as SettingsApiDocsGraphqlRouteImport } from './routes/settings/api-docs/graphql'
import { Route as SettingsApiDocsRestRouteImport } from './routes/settings/api-docs/rest'
import { Route as SettingsApiKeysIndexRouteImport } from './routes/settings/api-keys/index'
import { Route as SettingsPreferencesIndexRouteImport } from './routes/settings/preferences/index'
import { Route as StakeholdersStakeholderIdEditRouteImport } from './routes/stakeholders/$stakeholderId.edit'
import { Route as SuppliersSupplierIdEditRouteImport } from './routes/suppliers/$supplierId.edit'
import { Route as TagsTagIdEditRouteImport } from './routes/tags/$tagId.edit'
import { Route as TagsCategoriesNewRouteImport } from './routes/tags/categories/new'
import { Route as TeamsTeamIdEditRouteImport } from './routes/teams/$teamId.edit'
import { Route as TeamsTeamIdTrendsRouteImport } from './routes/teams/$teamId.trends'
import { Route as TechnologiesTechnologyIdEditRouteImport } from './routes/technologies/$technologyId.edit'
import { Route as TechnologiesRadarIndexRouteImport } from './routes/technologies/radar/index'
import { Route as TechnologyCapabilitiesTechnologyCapabilityIdEditRouteImport } from './routes/technology-capabilities/$technologyCapabilityId.edit'
import { Route as TechnologyDomainsTechnologyDomainIdEditRouteImport } from './routes/technology-domains/$technologyDomainId.edit'
import { Route as TechnologyFamiliesFamilyIdEditRouteImport } from './routes/technology-families/$familyId.edit'
import { Route as MaturityFrameworksFrameworkIdEditRouteImport } from './routes/maturity/frameworks/$frameworkId.edit'
import { Route as ServicesServiceIdAssessmentsAssessmentIdRouteImport } from './routes/services/$serviceId.assessments.$assessmentId'
import { Route as ServicesServiceIdAssessmentsNewRouteImport } from './routes/services/$serviceId.assessments.new'
import { Route as ServicesServiceIdAssessmentsTrendsRouteImport } from './routes/services/$serviceId.assessments.trends'
import { Route as TagsCategoriesCategoryIdEditRouteImport } from './routes/tags/categories/$categoryId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditIndexRoute = AuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessEnvironmentFactorsIndexRoute =
  BusinessEnvironmentFactorsIndexRouteImport.update({
    id: '/business-environment-factors/',
    path: '/business-environment-factors/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute =
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteImport.update({
    id: '/business-environment-factors/$businessEnvironmentFactorId',
    path: '/business-environment-factors/$businessEnvironmentFactorId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessEnvironmentFactorsNewRoute =
  BusinessEnvironmentFactorsNewRouteImport.update({
    id: '/business-environment-factors/new',
    path: '/business-environment-factors/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessObjectivesIndexRoute = BusinessObjectivesIndexRouteImport.update({
  id: '/business-objectives/',
  path: '/business-objectives/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessObjectivesBusinessObjectiveIdRoute =
  BusinessObjectivesBusinessObjectiveIdRouteImport.update({
    id: '/business-objectives/$businessObjectiveId',
    path: '/business-objectives/$businessObjectiveId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessObjectivesNewRoute = BusinessObjectivesNewRouteImport.update({
  id: '/business-objectives/new',
  path: '/business-objectives/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessProcessesIndexRoute = BusinessProcessesIndexRouteImport.update({
  id: '/business-processes/',
  path: '/business-processes/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessProcessesBusinessProcessIdRoute =
  BusinessProcessesBusinessProcessIdRouteImport.update({
    id: '/business-processes/$businessProcessId',
    path: '/business-processes/$businessProcessId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessProcessesNewRoute = BusinessProcessesNewRouteImport.update({
  id: '/business-processes/new',
  path: '/business-processes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessUnitsIndexRoute = BusinessUnitsIndexRouteImport.update({
  id: '/business-units/',
  path: '/business-units/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessUnitsBusinessUnitIdRoute =
  BusinessUnitsBusinessUnitIdRouteImport.update({
    id: '/business-units/$businessUnitId',
    path: '/business-units/$businessUnitId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessUnitsNewRoute = BusinessUnitsNewRouteImport.update({
  id: '/business-units/new',
  path: '/business-units/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CapabilitiesIndexRoute = CapabilitiesIndexRouteImport.update({
  id: '/capabilities/',
  path: '/capabilities/',
  getParentRoute: () => rootRouteImport,
} as any)
const CapabilitiesCapabilityIdRoute =
  CapabilitiesCapabilityIdRouteImport.update({
    id: '/capabilities/$capabilityId',
    path: '/capabilities/$capabilityId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CapabilitiesNewRoute = CapabilitiesNewRouteImport.update({
  id: '/capabilities/new',
  path: '/capabilities/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InformationIndexRoute = InformationIndexRouteImport.update({
  id: '/information/',
  path: '/information/',
  getParentRoute: () => rootRouteImport,
} as any)
const InformationDataDomainIdRoute = InformationDataDomainIdRouteImport.update({
  id: '/information/$dataDomainId',
  path: '/information/$dataDomainId',
  getParentRoute: () => rootRouteImport,
} as any)
const InformationNewRoute = InformationNewRouteImport.update({
  id: '/information/new',
  path: '/information/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PhysicalProcessesIndexRoute = PhysicalProcessesIndexRouteImport.update({
  id: '/physical-processes/',
  path: '/physical-processes/',
  getParentRoute: () => rootRouteImport,
} as any)
const PhysicalProcessesPhysicalProcessIdRoute =
  PhysicalProcessesPhysicalProcessIdRouteImport.update({
    id: '/physical-processes/$physicalProcessId',
    path: '/physical-processes/$physicalProcessId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PhysicalProcessesNewRoute = PhysicalProcessesNewRouteImport.update({
  id: '/physical-processes/new',
  path: '/physical-processes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesServiceIdRoute = ServicesServiceIdRouteImport.update({
  id: '/services/$serviceId',
  path: '/services/$serviceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesNewRoute = ServicesNewRouteImport.update({
  id: '/services/new',
  path: '/services/new',
  getParentRoute: () => rootRouteImport,
} as any)
const StakeholdersIndexRoute = StakeholdersIndexRouteImport.update({
  id: '/stakeholders/',
  path: '/stakeholders/',
  getParentRoute: () => rootRouteImport,
} as any)
const StakeholdersStakeholderIdRoute =
  StakeholdersStakeholderIdRouteImport.update({
    id: '/stakeholders/$stakeholderId',
    path: '/stakeholders/$stakeholderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StakeholdersNewRoute = StakeholdersNewRouteImport.update({
  id: '/stakeholders/new',
  path: '/stakeholders/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIndexRoute = SuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersNewRoute = SuppliersNewRouteImport.update({
  id: '/suppliers/new',
  path: '/suppliers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsIndexRoute = TagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsNewRoute = TagsNewRouteImport.update({
  id: '/tags/new',
  path: '/tags/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsIndexRoute = TeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsTeamIdRoute = TeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsNewRoute = TeamsNewRouteImport.update({
  id: '/teams/new',
  path: '/teams/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologiesIndexRoute = TechnologiesIndexRouteImport.update({
  id: '/technologies/',
  path: '/technologies/',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologiesTechnologyIdRoute =
  TechnologiesTechnologyIdRouteImport.update({
    id: '/technologies/$technologyId',
    path: '/technologies/$technologyId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TechnologiesNewRoute = TechnologiesNewRouteImport.update({
  id: '/technologies/new',
  path: '/technologies/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologyCapabilitiesIndexRoute =
  TechnologyCapabilitiesIndexRouteImport.update({
    id: '/technology-capabilities/',
    path: '/technology-capabilities/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TechnologyCapabilitiesTechnologyCapabilityIdRoute =
  TechnologyCapabilitiesTechnologyCapabilityIdRouteImport.update({
    id: '/technology-capabilities/$technologyCapabilityId',
    path: '/technology-capabilities/$technologyCapabilityId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TechnologyCapabilitiesNewRoute =
  TechnologyCapabilitiesNewRouteImport.update({
    id: '/technology-capabilities/new',
    path: '/technology-capabilities/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const TechnologyDomainsIndexRoute = TechnologyDomainsIndexRouteImport.update({
  id: '/technology-domains/',
  path: '/technology-domains/',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologyDomainsTechnologyDomainIdRoute =
  TechnologyDomainsTechnologyDomainIdRouteImport.update({
    id: '/technology-domains/$technologyDomainId',
    path: '/technology-domains/$technologyDomainId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TechnologyDomainsNewRoute = TechnologyDomainsNewRouteImport.update({
  id: '/technology-domains/new',
  path: '/technology-domains/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologyFamiliesIndexRoute = TechnologyFamiliesIndexRouteImport.update({
  id: '/technology-families/',
  path: '/technology-families/',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologyFamiliesNewRoute = TechnologyFamiliesNewRouteImport.update({
  id: '/technology-families/new',
  path: '/technology-families/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBulkOperationsIndexRoute =
  AdminBulkOperationsIndexRouteImport.update({
    id: '/admin/bulk-operations/',
    path: '/admin/bulk-operations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModelPackageIndexRoute = AdminModelPackageIndexRouteImport.update({
  id: '/admin/model-package/',
  path: '/admin/model-package/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute =
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute,
  } as any)
const BusinessObjectivesBusinessObjectiveIdEditRoute =
  BusinessObjectivesBusinessObjectiveIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => BusinessObjectivesBusinessObjectiveIdRoute,
  } as any)
const BusinessProcessesBusinessProcessIdEditRoute =
  BusinessProcessesBusinessProcessIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => BusinessProcessesBusinessProcessIdRoute,
  } as any)
const BusinessUnitsBusinessUnitIdEditRoute =
  BusinessUnitsBusinessUnitIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => BusinessUnitsBusinessUnitIdRoute,
  } as any)
const CapabilitiesCapabilityIdEditRoute =
  CapabilitiesCapabilityIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => CapabilitiesCapabilityIdRoute,
  } as any)
const InformationDataDomainIdEditRoute =
  InformationDataDomainIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => InformationDataDomainIdRoute,
  } as any)
const MaturityComparisonIndexRoute = MaturityComparisonIndexRouteImport.update({
  id: '/maturity/comparison/',
  path: '/maturity/comparison/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaturityFrameworksIndexRoute = MaturityFrameworksIndexRouteImport.update({
  id: '/maturity/frameworks/',
  path: '/maturity/frameworks/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaturityFrameworksFrameworkIdRoute =
  MaturityFrameworksFrameworkIdRouteImport.update({
    id: '/maturity/frameworks/$frameworkId',
    path: '/maturity/frameworks/$frameworkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MaturityFrameworksNewRoute = MaturityFrameworksNewRouteImport.update({
  id: '/maturity/frameworks/new',
  path: '/maturity/frameworks/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PhysicalProcessesPhysicalProcessIdEditRoute =
  PhysicalProcessesPhysicalProcessIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => PhysicalProcessesPhysicalProcessIdRoute,
  } as any)
const ProjectsProjectIdEditRoute = ProjectsProjectIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ServicesServiceIdAssessmentsRoute =
  ServicesServiceIdAssessmentsRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => ServicesServiceIdRoute,
  } as any)
const ServicesServiceIdDependenciesRoute =
  ServicesServiceIdDependenciesRouteImport.update({
    id: '/dependencies',
    path: '/dependencies',
    getParentRoute: () => ServicesServiceIdRoute,
  } as any)
const ServicesServiceIdDiagramsRoute =
  ServicesServiceIdDiagramsRouteImport.update({
    id: '/diagrams',
    path: '/diagrams',
    getParentRoute: () => ServicesServiceIdRoute,
  } as any)
const ServicesServiceIdEditRoute = ServicesServiceIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ServicesServiceIdRoute,
} as any)
const ServicesServiceIdImpactRoute = ServicesServiceIdImpactRouteImport.update({
  id: '/impact',
  path: '/impact',
  getParentRoute: () => ServicesServiceIdRoute,
} as any)
const SettingsApiDocsIndexRoute = SettingsApiDocsIndexRouteImport.update({
  id: '/settings/api-docs/',
  path: '/settings/api-docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiDocsGraphqlRoute = SettingsApiDocsGraphqlRouteImport.update({
  id: '/settings/api-docs/graphql',
  path: '/settings/api-docs/graphql',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiDocsRestRoute = SettingsApiDocsRestRouteImport.update({
  id: '/settings/api-docs/rest',
  path: '/settings/api-docs/rest',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiKeysIndexRoute = SettingsApiKeysIndexRouteImport.update({
  id: '/settings/api-keys/',
  path: '/settings/api-keys/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreferencesIndexRoute =
  SettingsPreferencesIndexRouteImport.update({
    id: '/settings/preferences/',
    path: '/settings/preferences/',
    getParentRoute: () => rootRouteImport,
  } as any)
const StakeholdersStakeholderIdEditRoute =
  StakeholdersStakeholderIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StakeholdersStakeholderIdRoute,
  } as any)
const SuppliersSupplierIdEditRoute = SuppliersSupplierIdEditRouteImport.update({
  id: '/suppliers/$supplierId/edit',
  path: '/suppliers/$supplierId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsTagIdEditRoute = TagsTagIdEditRouteImport.update({
  id: '/tags/$tagId/edit',
  path: '/tags/$tagId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsCategoriesNewRoute = TagsCategoriesNewRouteImport.update({
  id: '/tags/categories/new',
  path: '/tags/categories/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsTeamIdEditRoute = TeamsTeamIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => TeamsTeamIdRoute,
} as any)
const TeamsTeamIdTrendsRoute = TeamsTeamIdTrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => TeamsTeamIdRoute,
} as any)
const TechnologiesTechnologyIdEditRoute =
  TechnologiesTechnologyIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => TechnologiesTechnologyIdRoute,
  } as any)
const TechnologiesRadarIndexRoute = TechnologiesRadarIndexRouteImport.update({
  id: '/technologies/radar/',
  path: '/technologies/radar/',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnologyCapabilitiesTechnologyCapabilityIdEditRoute =
  TechnologyCapabilitiesTechnologyCapabilityIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => TechnologyCapabilitiesTechnologyCapabilityIdRoute,
  } as any)
const TechnologyDomainsTechnologyDomainIdEditRoute =
  TechnologyDomainsTechnologyDomainIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => TechnologyDomainsTechnologyDomainIdRoute,
  } as any)
const TechnologyFamiliesFamilyIdEditRoute =
  TechnologyFamiliesFamilyIdEditRouteImport.update({
    id: '/technology-families/$familyId/edit',
    path: '/technology-families/$familyId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const MaturityFrameworksFrameworkIdEditRoute =
  MaturityFrameworksFrameworkIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MaturityFrameworksFrameworkIdRoute,
  } as any)
const ServicesServiceIdAssessmentsAssessmentIdRoute =
  ServicesServiceIdAssessmentsAssessmentIdRouteImport.update({
    id: '/$assessmentId',
    path: '/$assessmentId',
    getParentRoute: () => ServicesServiceIdAssessmentsRoute,
  } as any)
const ServicesServiceIdAssessmentsNewRoute =
  ServicesServiceIdAssessmentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ServicesServiceIdAssessmentsRoute,
  } as any)
const ServicesServiceIdAssessmentsTrendsRoute =
  ServicesServiceIdAssessmentsTrendsRouteImport.update({
    id: '/trends',
    path: '/trends',
    getParentRoute: () => ServicesServiceIdAssessmentsRoute,
  } as any)
const TagsCategoriesCategoryIdEditRoute =
  TagsCategoriesCategoryIdEditRouteImport.update({
    id: '/tags/categories/$categoryId/edit',
    path: '/tags/categories/$categoryId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/business-environment-factors/$businessEnvironmentFactorId': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren
  '/business-environment-factors/new': typeof BusinessEnvironmentFactorsNewRoute
  '/business-objectives/$businessObjectiveId': typeof BusinessObjectivesBusinessObjectiveIdRouteWithChildren
  '/business-objectives/new': typeof BusinessObjectivesNewRoute
  '/business-processes/$businessProcessId': typeof BusinessProcessesBusinessProcessIdRouteWithChildren
  '/business-processes/new': typeof BusinessProcessesNewRoute
  '/business-units/$businessUnitId': typeof BusinessUnitsBusinessUnitIdRouteWithChildren
  '/business-units/new': typeof BusinessUnitsNewRoute
  '/capabilities/$capabilityId': typeof CapabilitiesCapabilityIdRouteWithChildren
  '/capabilities/new': typeof CapabilitiesNewRoute
  '/information/$dataDomainId': typeof InformationDataDomainIdRouteWithChildren
  '/information/new': typeof InformationNewRoute
  '/physical-processes/$physicalProcessId': typeof PhysicalProcessesPhysicalProcessIdRouteWithChildren
  '/physical-processes/new': typeof PhysicalProcessesNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/new': typeof ServicesNewRoute
  '/stakeholders/$stakeholderId': typeof StakeholdersStakeholderIdRouteWithChildren
  '/stakeholders/new': typeof StakeholdersNewRoute
  '/suppliers/new': typeof SuppliersNewRoute
  '/tags/new': typeof TagsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/teams/$teamId': typeof TeamsTeamIdRouteWithChildren
  '/teams/new': typeof TeamsNewRoute
  '/technologies/$technologyId': typeof TechnologiesTechnologyIdRouteWithChildren
  '/technologies/new': typeof TechnologiesNewRoute
  '/technology-capabilities/$technologyCapabilityId': typeof TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren
  '/technology-capabilities/new': typeof TechnologyCapabilitiesNewRoute
  '/technology-domains/$technologyDomainId': typeof TechnologyDomainsTechnologyDomainIdRouteWithChildren
  '/technology-domains/new': typeof TechnologyDomainsNewRoute
  '/technology-families/new': typeof TechnologyFamiliesNewRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/audit/': typeof AuditIndexRoute
  '/business-environment-factors/': typeof BusinessEnvironmentFactorsIndexRoute
  '/business-objectives/': typeof BusinessObjectivesIndexRoute
  '/business-processes/': typeof BusinessProcessesIndexRoute
  '/business-units/': typeof BusinessUnitsIndexRoute
  '/capabilities/': typeof CapabilitiesIndexRoute
  '/information/': typeof InformationIndexRoute
  '/physical-processes/': typeof PhysicalProcessesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/stakeholders/': typeof StakeholdersIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/tags/': typeof TagsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/technologies/': typeof TechnologiesIndexRoute
  '/technology-capabilities/': typeof TechnologyCapabilitiesIndexRoute
  '/technology-domains/': typeof TechnologyDomainsIndexRoute
  '/technology-families/': typeof TechnologyFamiliesIndexRoute
  '/business-environment-factors/$businessEnvironmentFactorId/edit': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute
  '/business-objectives/$businessObjectiveId/edit': typeof BusinessObjectivesBusinessObjectiveIdEditRoute
  '/business-processes/$businessProcessId/edit': typeof BusinessProcessesBusinessProcessIdEditRoute
  '/business-units/$businessUnitId/edit': typeof BusinessUnitsBusinessUnitIdEditRoute
  '/capabilities/$capabilityId/edit': typeof CapabilitiesCapabilityIdEditRoute
  '/information/$dataDomainId/edit': typeof InformationDataDomainIdEditRoute
  '/maturity/frameworks/$frameworkId': typeof MaturityFrameworksFrameworkIdRouteWithChildren
  '/maturity/frameworks/new': typeof MaturityFrameworksNewRoute
  '/physical-processes/$physicalProcessId/edit': typeof PhysicalProcessesPhysicalProcessIdEditRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/services/$serviceId/assessments': typeof ServicesServiceIdAssessmentsRouteWithChildren
  '/services/$serviceId/dependencies': typeof ServicesServiceIdDependenciesRoute
  '/services/$serviceId/diagrams': typeof ServicesServiceIdDiagramsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/services/$serviceId/impact': typeof ServicesServiceIdImpactRoute
  '/settings/api-docs/graphql': typeof SettingsApiDocsGraphqlRoute
  '/settings/api-docs/rest': typeof SettingsApiDocsRestRoute
  '/stakeholders/$stakeholderId/edit': typeof StakeholdersStakeholderIdEditRoute
  '/suppliers/$supplierId/edit': typeof SuppliersSupplierIdEditRoute
  '/tags/$tagId/edit': typeof TagsTagIdEditRoute
  '/tags/categories/new': typeof TagsCategoriesNewRoute
  '/teams/$teamId/edit': typeof TeamsTeamIdEditRoute
  '/teams/$teamId/trends': typeof TeamsTeamIdTrendsRoute
  '/technologies/$technologyId/edit': typeof TechnologiesTechnologyIdEditRoute
  '/technology-capabilities/$technologyCapabilityId/edit': typeof TechnologyCapabilitiesTechnologyCapabilityIdEditRoute
  '/technology-domains/$technologyDomainId/edit': typeof TechnologyDomainsTechnologyDomainIdEditRoute
  '/technology-families/$familyId/edit': typeof TechnologyFamiliesFamilyIdEditRoute
  '/admin/bulk-operations/': typeof AdminBulkOperationsIndexRoute
  '/admin/model-package/': typeof AdminModelPackageIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/maturity/comparison/': typeof MaturityComparisonIndexRoute
  '/maturity/frameworks/': typeof MaturityFrameworksIndexRoute
  '/settings/api-docs/': typeof SettingsApiDocsIndexRoute
  '/settings/api-keys/': typeof SettingsApiKeysIndexRoute
  '/settings/preferences/': typeof SettingsPreferencesIndexRoute
  '/technologies/radar/': typeof TechnologiesRadarIndexRoute
  '/maturity/frameworks/$frameworkId/edit': typeof MaturityFrameworksFrameworkIdEditRoute
  '/services/$serviceId/assessments/$assessmentId': typeof ServicesServiceIdAssessmentsAssessmentIdRoute
  '/services/$serviceId/assessments/new': typeof ServicesServiceIdAssessmentsNewRoute
  '/services/$serviceId/assessments/trends': typeof ServicesServiceIdAssessmentsTrendsRoute
  '/tags/categories/$categoryId/edit': typeof TagsCategoriesCategoryIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/business-environment-factors/$businessEnvironmentFactorId': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren
  '/business-environment-factors/new': typeof BusinessEnvironmentFactorsNewRoute
  '/business-objectives/$businessObjectiveId': typeof BusinessObjectivesBusinessObjectiveIdRouteWithChildren
  '/business-objectives/new': typeof BusinessObjectivesNewRoute
  '/business-processes/$businessProcessId': typeof BusinessProcessesBusinessProcessIdRouteWithChildren
  '/business-processes/new': typeof BusinessProcessesNewRoute
  '/business-units/$businessUnitId': typeof BusinessUnitsBusinessUnitIdRouteWithChildren
  '/business-units/new': typeof BusinessUnitsNewRoute
  '/capabilities/$capabilityId': typeof CapabilitiesCapabilityIdRouteWithChildren
  '/capabilities/new': typeof CapabilitiesNewRoute
  '/information/$dataDomainId': typeof InformationDataDomainIdRouteWithChildren
  '/information/new': typeof InformationNewRoute
  '/physical-processes/$physicalProcessId': typeof PhysicalProcessesPhysicalProcessIdRouteWithChildren
  '/physical-processes/new': typeof PhysicalProcessesNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/new': typeof ServicesNewRoute
  '/stakeholders/$stakeholderId': typeof StakeholdersStakeholderIdRouteWithChildren
  '/stakeholders/new': typeof StakeholdersNewRoute
  '/suppliers/new': typeof SuppliersNewRoute
  '/tags/new': typeof TagsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/teams/$teamId': typeof TeamsTeamIdRouteWithChildren
  '/teams/new': typeof TeamsNewRoute
  '/technologies/$technologyId': typeof TechnologiesTechnologyIdRouteWithChildren
  '/technologies/new': typeof TechnologiesNewRoute
  '/technology-capabilities/$technologyCapabilityId': typeof TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren
  '/technology-capabilities/new': typeof TechnologyCapabilitiesNewRoute
  '/technology-domains/$technologyDomainId': typeof TechnologyDomainsTechnologyDomainIdRouteWithChildren
  '/technology-domains/new': typeof TechnologyDomainsNewRoute
  '/technology-families/new': typeof TechnologyFamiliesNewRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/audit': typeof AuditIndexRoute
  '/business-environment-factors': typeof BusinessEnvironmentFactorsIndexRoute
  '/business-objectives': typeof BusinessObjectivesIndexRoute
  '/business-processes': typeof BusinessProcessesIndexRoute
  '/business-units': typeof BusinessUnitsIndexRoute
  '/capabilities': typeof CapabilitiesIndexRoute
  '/information': typeof InformationIndexRoute
  '/physical-processes': typeof PhysicalProcessesIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/services': typeof ServicesIndexRoute
  '/stakeholders': typeof StakeholdersIndexRoute
  '/suppliers': typeof SuppliersIndexRoute
  '/tags': typeof TagsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/teams': typeof TeamsIndexRoute
  '/technologies': typeof TechnologiesIndexRoute
  '/technology-capabilities': typeof TechnologyCapabilitiesIndexRoute
  '/technology-domains': typeof TechnologyDomainsIndexRoute
  '/technology-families': typeof TechnologyFamiliesIndexRoute
  '/business-environment-factors/$businessEnvironmentFactorId/edit': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute
  '/business-objectives/$businessObjectiveId/edit': typeof BusinessObjectivesBusinessObjectiveIdEditRoute
  '/business-processes/$businessProcessId/edit': typeof BusinessProcessesBusinessProcessIdEditRoute
  '/business-units/$businessUnitId/edit': typeof BusinessUnitsBusinessUnitIdEditRoute
  '/capabilities/$capabilityId/edit': typeof CapabilitiesCapabilityIdEditRoute
  '/information/$dataDomainId/edit': typeof InformationDataDomainIdEditRoute
  '/maturity/frameworks/$frameworkId': typeof MaturityFrameworksFrameworkIdRouteWithChildren
  '/maturity/frameworks/new': typeof MaturityFrameworksNewRoute
  '/physical-processes/$physicalProcessId/edit': typeof PhysicalProcessesPhysicalProcessIdEditRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/services/$serviceId/assessments': typeof ServicesServiceIdAssessmentsRouteWithChildren
  '/services/$serviceId/dependencies': typeof ServicesServiceIdDependenciesRoute
  '/services/$serviceId/diagrams': typeof ServicesServiceIdDiagramsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/services/$serviceId/impact': typeof ServicesServiceIdImpactRoute
  '/settings/api-docs/graphql': typeof SettingsApiDocsGraphqlRoute
  '/settings/api-docs/rest': typeof SettingsApiDocsRestRoute
  '/stakeholders/$stakeholderId/edit': typeof StakeholdersStakeholderIdEditRoute
  '/suppliers/$supplierId/edit': typeof SuppliersSupplierIdEditRoute
  '/tags/$tagId/edit': typeof TagsTagIdEditRoute
  '/tags/categories/new': typeof TagsCategoriesNewRoute
  '/teams/$teamId/edit': typeof TeamsTeamIdEditRoute
  '/teams/$teamId/trends': typeof TeamsTeamIdTrendsRoute
  '/technologies/$technologyId/edit': typeof TechnologiesTechnologyIdEditRoute
  '/technology-capabilities/$technologyCapabilityId/edit': typeof TechnologyCapabilitiesTechnologyCapabilityIdEditRoute
  '/technology-domains/$technologyDomainId/edit': typeof TechnologyDomainsTechnologyDomainIdEditRoute
  '/technology-families/$familyId/edit': typeof TechnologyFamiliesFamilyIdEditRoute
  '/admin/bulk-operations': typeof AdminBulkOperationsIndexRoute
  '/admin/model-package': typeof AdminModelPackageIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/maturity/comparison': typeof MaturityComparisonIndexRoute
  '/maturity/frameworks': typeof MaturityFrameworksIndexRoute
  '/settings/api-docs': typeof SettingsApiDocsIndexRoute
  '/settings/api-keys': typeof SettingsApiKeysIndexRoute
  '/settings/preferences': typeof SettingsPreferencesIndexRoute
  '/technologies/radar': typeof TechnologiesRadarIndexRoute
  '/maturity/frameworks/$frameworkId/edit': typeof MaturityFrameworksFrameworkIdEditRoute
  '/services/$serviceId/assessments/$assessmentId': typeof ServicesServiceIdAssessmentsAssessmentIdRoute
  '/services/$serviceId/assessments/new': typeof ServicesServiceIdAssessmentsNewRoute
  '/services/$serviceId/assessments/trends': typeof ServicesServiceIdAssessmentsTrendsRoute
  '/tags/categories/$categoryId/edit': typeof TagsCategoriesCategoryIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/business-environment-factors/$businessEnvironmentFactorId': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren
  '/business-environment-factors/new': typeof BusinessEnvironmentFactorsNewRoute
  '/business-objectives/$businessObjectiveId': typeof BusinessObjectivesBusinessObjectiveIdRouteWithChildren
  '/business-objectives/new': typeof BusinessObjectivesNewRoute
  '/business-processes/$businessProcessId': typeof BusinessProcessesBusinessProcessIdRouteWithChildren
  '/business-processes/new': typeof BusinessProcessesNewRoute
  '/business-units/$businessUnitId': typeof BusinessUnitsBusinessUnitIdRouteWithChildren
  '/business-units/new': typeof BusinessUnitsNewRoute
  '/capabilities/$capabilityId': typeof CapabilitiesCapabilityIdRouteWithChildren
  '/capabilities/new': typeof CapabilitiesNewRoute
  '/information/$dataDomainId': typeof InformationDataDomainIdRouteWithChildren
  '/information/new': typeof InformationNewRoute
  '/physical-processes/$physicalProcessId': typeof PhysicalProcessesPhysicalProcessIdRouteWithChildren
  '/physical-processes/new': typeof PhysicalProcessesNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/new': typeof ServicesNewRoute
  '/stakeholders/$stakeholderId': typeof StakeholdersStakeholderIdRouteWithChildren
  '/stakeholders/new': typeof StakeholdersNewRoute
  '/suppliers/new': typeof SuppliersNewRoute
  '/tags/new': typeof TagsNewRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/teams/$teamId': typeof TeamsTeamIdRouteWithChildren
  '/teams/new': typeof TeamsNewRoute
  '/technologies/$technologyId': typeof TechnologiesTechnologyIdRouteWithChildren
  '/technologies/new': typeof TechnologiesNewRoute
  '/technology-capabilities/$technologyCapabilityId': typeof TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren
  '/technology-capabilities/new': typeof TechnologyCapabilitiesNewRoute
  '/technology-domains/$technologyDomainId': typeof TechnologyDomainsTechnologyDomainIdRouteWithChildren
  '/technology-domains/new': typeof TechnologyDomainsNewRoute
  '/technology-families/new': typeof TechnologyFamiliesNewRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/audit/': typeof AuditIndexRoute
  '/business-environment-factors/': typeof BusinessEnvironmentFactorsIndexRoute
  '/business-objectives/': typeof BusinessObjectivesIndexRoute
  '/business-processes/': typeof BusinessProcessesIndexRoute
  '/business-units/': typeof BusinessUnitsIndexRoute
  '/capabilities/': typeof CapabilitiesIndexRoute
  '/information/': typeof InformationIndexRoute
  '/physical-processes/': typeof PhysicalProcessesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/stakeholders/': typeof StakeholdersIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/tags/': typeof TagsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/technologies/': typeof TechnologiesIndexRoute
  '/technology-capabilities/': typeof TechnologyCapabilitiesIndexRoute
  '/technology-domains/': typeof TechnologyDomainsIndexRoute
  '/technology-families/': typeof TechnologyFamiliesIndexRoute
  '/business-environment-factors/$businessEnvironmentFactorId/edit': typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute
  '/business-objectives/$businessObjectiveId/edit': typeof BusinessObjectivesBusinessObjectiveIdEditRoute
  '/business-processes/$businessProcessId/edit': typeof BusinessProcessesBusinessProcessIdEditRoute
  '/business-units/$businessUnitId/edit': typeof BusinessUnitsBusinessUnitIdEditRoute
  '/capabilities/$capabilityId/edit': typeof CapabilitiesCapabilityIdEditRoute
  '/information/$dataDomainId/edit': typeof InformationDataDomainIdEditRoute
  '/maturity/frameworks/$frameworkId': typeof MaturityFrameworksFrameworkIdRouteWithChildren
  '/maturity/frameworks/new': typeof MaturityFrameworksNewRoute
  '/physical-processes/$physicalProcessId/edit': typeof PhysicalProcessesPhysicalProcessIdEditRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/services/$serviceId/assessments': typeof ServicesServiceIdAssessmentsRouteWithChildren
  '/services/$serviceId/dependencies': typeof ServicesServiceIdDependenciesRoute
  '/services/$serviceId/diagrams': typeof ServicesServiceIdDiagramsRoute
  '/services/$serviceId/edit': typeof ServicesServiceIdEditRoute
  '/services/$serviceId/impact': typeof ServicesServiceIdImpactRoute
  '/settings/api-docs/graphql': typeof SettingsApiDocsGraphqlRoute
  '/settings/api-docs/rest': typeof SettingsApiDocsRestRoute
  '/stakeholders/$stakeholderId/edit': typeof StakeholdersStakeholderIdEditRoute
  '/suppliers/$supplierId/edit': typeof SuppliersSupplierIdEditRoute
  '/tags/$tagId/edit': typeof TagsTagIdEditRoute
  '/tags/categories/new': typeof TagsCategoriesNewRoute
  '/teams/$teamId/edit': typeof TeamsTeamIdEditRoute
  '/teams/$teamId/trends': typeof TeamsTeamIdTrendsRoute
  '/technologies/$technologyId/edit': typeof TechnologiesTechnologyIdEditRoute
  '/technology-capabilities/$technologyCapabilityId/edit': typeof TechnologyCapabilitiesTechnologyCapabilityIdEditRoute
  '/technology-domains/$technologyDomainId/edit': typeof TechnologyDomainsTechnologyDomainIdEditRoute
  '/technology-families/$familyId/edit': typeof TechnologyFamiliesFamilyIdEditRoute
  '/admin/bulk-operations/': typeof AdminBulkOperationsIndexRoute
  '/admin/model-package/': typeof AdminModelPackageIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/maturity/comparison/': typeof MaturityComparisonIndexRoute
  '/maturity/frameworks/': typeof MaturityFrameworksIndexRoute
  '/settings/api-docs/': typeof SettingsApiDocsIndexRoute
  '/settings/api-keys/': typeof SettingsApiKeysIndexRoute
  '/settings/preferences/': typeof SettingsPreferencesIndexRoute
  '/technologies/radar/': typeof TechnologiesRadarIndexRoute
  '/maturity/frameworks/$frameworkId/edit': typeof MaturityFrameworksFrameworkIdEditRoute
  '/services/$serviceId/assessments/$assessmentId': typeof ServicesServiceIdAssessmentsAssessmentIdRoute
  '/services/$serviceId/assessments/new': typeof ServicesServiceIdAssessmentsNewRoute
  '/services/$serviceId/assessments/trends': typeof ServicesServiceIdAssessmentsTrendsRoute
  '/tags/categories/$categoryId/edit': typeof TagsCategoriesCategoryIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/callback'
    | '/business-environment-factors/$businessEnvironmentFactorId'
    | '/business-environment-factors/new'
    | '/business-objectives/$businessObjectiveId'
    | '/business-objectives/new'
    | '/business-processes/$businessProcessId'
    | '/business-processes/new'
    | '/business-units/$businessUnitId'
    | '/business-units/new'
    | '/capabilities/$capabilityId'
    | '/capabilities/new'
    | '/information/$dataDomainId'
    | '/information/new'
    | '/physical-processes/$physicalProcessId'
    | '/physical-processes/new'
    | '/projects/$projectId'
    | '/projects/new'
    | '/services/$serviceId'
    | '/services/new'
    | '/stakeholders/$stakeholderId'
    | '/stakeholders/new'
    | '/suppliers/new'
    | '/tags/new'
    | '/tasks/$taskId'
    | '/teams/$teamId'
    | '/teams/new'
    | '/technologies/$technologyId'
    | '/technologies/new'
    | '/technology-capabilities/$technologyCapabilityId'
    | '/technology-capabilities/new'
    | '/technology-domains/$technologyDomainId'
    | '/technology-domains/new'
    | '/technology-families/new'
    | '/analytics/'
    | '/audit/'
    | '/business-environment-factors/'
    | '/business-objectives/'
    | '/business-processes/'
    | '/business-units/'
    | '/capabilities/'
    | '/information/'
    | '/physical-processes/'
    | '/projects/'
    | '/services/'
    | '/stakeholders/'
    | '/suppliers/'
    | '/tags/'
    | '/tasks/'
    | '/teams/'
    | '/technologies/'
    | '/technology-capabilities/'
    | '/technology-domains/'
    | '/technology-families/'
    | '/business-environment-factors/$businessEnvironmentFactorId/edit'
    | '/business-objectives/$businessObjectiveId/edit'
    | '/business-processes/$businessProcessId/edit'
    | '/business-units/$businessUnitId/edit'
    | '/capabilities/$capabilityId/edit'
    | '/information/$dataDomainId/edit'
    | '/maturity/frameworks/$frameworkId'
    | '/maturity/frameworks/new'
    | '/physical-processes/$physicalProcessId/edit'
    | '/projects/$projectId/edit'
    | '/services/$serviceId/assessments'
    | '/services/$serviceId/dependencies'
    | '/services/$serviceId/diagrams'
    | '/services/$serviceId/edit'
    | '/services/$serviceId/impact'
    | '/settings/api-docs/graphql'
    | '/settings/api-docs/rest'
    | '/stakeholders/$stakeholderId/edit'
    | '/suppliers/$supplierId/edit'
    | '/tags/$tagId/edit'
    | '/tags/categories/new'
    | '/teams/$teamId/edit'
    | '/teams/$teamId/trends'
    | '/technologies/$technologyId/edit'
    | '/technology-capabilities/$technologyCapabilityId/edit'
    | '/technology-domains/$technologyDomainId/edit'
    | '/technology-families/$familyId/edit'
    | '/admin/bulk-operations/'
    | '/admin/model-package/'
    | '/admin/users/'
    | '/maturity/comparison/'
    | '/maturity/frameworks/'
    | '/settings/api-docs/'
    | '/settings/api-keys/'
    | '/settings/preferences/'
    | '/technologies/radar/'
    | '/maturity/frameworks/$frameworkId/edit'
    | '/services/$serviceId/assessments/$assessmentId'
    | '/services/$serviceId/assessments/new'
    | '/services/$serviceId/assessments/trends'
    | '/tags/categories/$categoryId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/callback'
    | '/business-environment-factors/$businessEnvironmentFactorId'
    | '/business-environment-factors/new'
    | '/business-objectives/$businessObjectiveId'
    | '/business-objectives/new'
    | '/business-processes/$businessProcessId'
    | '/business-processes/new'
    | '/business-units/$businessUnitId'
    | '/business-units/new'
    | '/capabilities/$capabilityId'
    | '/capabilities/new'
    | '/information/$dataDomainId'
    | '/information/new'
    | '/physical-processes/$physicalProcessId'
    | '/physical-processes/new'
    | '/projects/$projectId'
    | '/projects/new'
    | '/services/$serviceId'
    | '/services/new'
    | '/stakeholders/$stakeholderId'
    | '/stakeholders/new'
    | '/suppliers/new'
    | '/tags/new'
    | '/tasks/$taskId'
    | '/teams/$teamId'
    | '/teams/new'
    | '/technologies/$technologyId'
    | '/technologies/new'
    | '/technology-capabilities/$technologyCapabilityId'
    | '/technology-capabilities/new'
    | '/technology-domains/$technologyDomainId'
    | '/technology-domains/new'
    | '/technology-families/new'
    | '/analytics'
    | '/audit'
    | '/business-environment-factors'
    | '/business-objectives'
    | '/business-processes'
    | '/business-units'
    | '/capabilities'
    | '/information'
    | '/physical-processes'
    | '/projects'
    | '/services'
    | '/stakeholders'
    | '/suppliers'
    | '/tags'
    | '/tasks'
    | '/teams'
    | '/technologies'
    | '/technology-capabilities'
    | '/technology-domains'
    | '/technology-families'
    | '/business-environment-factors/$businessEnvironmentFactorId/edit'
    | '/business-objectives/$businessObjectiveId/edit'
    | '/business-processes/$businessProcessId/edit'
    | '/business-units/$businessUnitId/edit'
    | '/capabilities/$capabilityId/edit'
    | '/information/$dataDomainId/edit'
    | '/maturity/frameworks/$frameworkId'
    | '/maturity/frameworks/new'
    | '/physical-processes/$physicalProcessId/edit'
    | '/projects/$projectId/edit'
    | '/services/$serviceId/assessments'
    | '/services/$serviceId/dependencies'
    | '/services/$serviceId/diagrams'
    | '/services/$serviceId/edit'
    | '/services/$serviceId/impact'
    | '/settings/api-docs/graphql'
    | '/settings/api-docs/rest'
    | '/stakeholders/$stakeholderId/edit'
    | '/suppliers/$supplierId/edit'
    | '/tags/$tagId/edit'
    | '/tags/categories/new'
    | '/teams/$teamId/edit'
    | '/teams/$teamId/trends'
    | '/technologies/$technologyId/edit'
    | '/technology-capabilities/$technologyCapabilityId/edit'
    | '/technology-domains/$technologyDomainId/edit'
    | '/technology-families/$familyId/edit'
    | '/admin/bulk-operations'
    | '/admin/model-package'
    | '/admin/users'
    | '/maturity/comparison'
    | '/maturity/frameworks'
    | '/settings/api-docs'
    | '/settings/api-keys'
    | '/settings/preferences'
    | '/technologies/radar'
    | '/maturity/frameworks/$frameworkId/edit'
    | '/services/$serviceId/assessments/$assessmentId'
    | '/services/$serviceId/assessments/new'
    | '/services/$serviceId/assessments/trends'
    | '/tags/categories/$categoryId/edit'
  id:
    | '__root__'
    | '/'
    | '/auth/callback'
    | '/business-environment-factors/$businessEnvironmentFactorId'
    | '/business-environment-factors/new'
    | '/business-objectives/$businessObjectiveId'
    | '/business-objectives/new'
    | '/business-processes/$businessProcessId'
    | '/business-processes/new'
    | '/business-units/$businessUnitId'
    | '/business-units/new'
    | '/capabilities/$capabilityId'
    | '/capabilities/new'
    | '/information/$dataDomainId'
    | '/information/new'
    | '/physical-processes/$physicalProcessId'
    | '/physical-processes/new'
    | '/projects/$projectId'
    | '/projects/new'
    | '/services/$serviceId'
    | '/services/new'
    | '/stakeholders/$stakeholderId'
    | '/stakeholders/new'
    | '/suppliers/new'
    | '/tags/new'
    | '/tasks/$taskId'
    | '/teams/$teamId'
    | '/teams/new'
    | '/technologies/$technologyId'
    | '/technologies/new'
    | '/technology-capabilities/$technologyCapabilityId'
    | '/technology-capabilities/new'
    | '/technology-domains/$technologyDomainId'
    | '/technology-domains/new'
    | '/technology-families/new'
    | '/analytics/'
    | '/audit/'
    | '/business-environment-factors/'
    | '/business-objectives/'
    | '/business-processes/'
    | '/business-units/'
    | '/capabilities/'
    | '/information/'
    | '/physical-processes/'
    | '/projects/'
    | '/services/'
    | '/stakeholders/'
    | '/suppliers/'
    | '/tags/'
    | '/tasks/'
    | '/teams/'
    | '/technologies/'
    | '/technology-capabilities/'
    | '/technology-domains/'
    | '/technology-families/'
    | '/business-environment-factors/$businessEnvironmentFactorId/edit'
    | '/business-objectives/$businessObjectiveId/edit'
    | '/business-processes/$businessProcessId/edit'
    | '/business-units/$businessUnitId/edit'
    | '/capabilities/$capabilityId/edit'
    | '/information/$dataDomainId/edit'
    | '/maturity/frameworks/$frameworkId'
    | '/maturity/frameworks/new'
    | '/physical-processes/$physicalProcessId/edit'
    | '/projects/$projectId/edit'
    | '/services/$serviceId/assessments'
    | '/services/$serviceId/dependencies'
    | '/services/$serviceId/diagrams'
    | '/services/$serviceId/edit'
    | '/services/$serviceId/impact'
    | '/settings/api-docs/graphql'
    | '/settings/api-docs/rest'
    | '/stakeholders/$stakeholderId/edit'
    | '/suppliers/$supplierId/edit'
    | '/tags/$tagId/edit'
    | '/tags/categories/new'
    | '/teams/$teamId/edit'
    | '/teams/$teamId/trends'
    | '/technologies/$technologyId/edit'
    | '/technology-capabilities/$technologyCapabilityId/edit'
    | '/technology-domains/$technologyDomainId/edit'
    | '/technology-families/$familyId/edit'
    | '/admin/bulk-operations/'
    | '/admin/model-package/'
    | '/admin/users/'
    | '/maturity/comparison/'
    | '/maturity/frameworks/'
    | '/settings/api-docs/'
    | '/settings/api-keys/'
    | '/settings/preferences/'
    | '/technologies/radar/'
    | '/maturity/frameworks/$frameworkId/edit'
    | '/services/$serviceId/assessments/$assessmentId'
    | '/services/$serviceId/assessments/new'
    | '/services/$serviceId/assessments/trends'
    | '/tags/categories/$categoryId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute: typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren
  BusinessEnvironmentFactorsNewRoute: typeof BusinessEnvironmentFactorsNewRoute
  BusinessObjectivesBusinessObjectiveIdRoute: typeof BusinessObjectivesBusinessObjectiveIdRouteWithChildren
  BusinessObjectivesNewRoute: typeof BusinessObjectivesNewRoute
  BusinessProcessesBusinessProcessIdRoute: typeof BusinessProcessesBusinessProcessIdRouteWithChildren
  BusinessProcessesNewRoute: typeof BusinessProcessesNewRoute
  BusinessUnitsBusinessUnitIdRoute: typeof BusinessUnitsBusinessUnitIdRouteWithChildren
  BusinessUnitsNewRoute: typeof BusinessUnitsNewRoute
  CapabilitiesCapabilityIdRoute: typeof CapabilitiesCapabilityIdRouteWithChildren
  CapabilitiesNewRoute: typeof CapabilitiesNewRoute
  InformationDataDomainIdRoute: typeof InformationDataDomainIdRouteWithChildren
  InformationNewRoute: typeof InformationNewRoute
  PhysicalProcessesPhysicalProcessIdRoute: typeof PhysicalProcessesPhysicalProcessIdRouteWithChildren
  PhysicalProcessesNewRoute: typeof PhysicalProcessesNewRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ProjectsNewRoute: typeof ProjectsNewRoute
  ServicesServiceIdRoute: typeof ServicesServiceIdRouteWithChildren
  ServicesNewRoute: typeof ServicesNewRoute
  StakeholdersStakeholderIdRoute: typeof StakeholdersStakeholderIdRouteWithChildren
  StakeholdersNewRoute: typeof StakeholdersNewRoute
  SuppliersNewRoute: typeof SuppliersNewRoute
  TagsNewRoute: typeof TagsNewRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TeamsTeamIdRoute: typeof TeamsTeamIdRouteWithChildren
  TeamsNewRoute: typeof TeamsNewRoute
  TechnologiesTechnologyIdRoute: typeof TechnologiesTechnologyIdRouteWithChildren
  TechnologiesNewRoute: typeof TechnologiesNewRoute
  TechnologyCapabilitiesTechnologyCapabilityIdRoute: typeof TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren
  TechnologyCapabilitiesNewRoute: typeof TechnologyCapabilitiesNewRoute
  TechnologyDomainsTechnologyDomainIdRoute: typeof TechnologyDomainsTechnologyDomainIdRouteWithChildren
  TechnologyDomainsNewRoute: typeof TechnologyDomainsNewRoute
  TechnologyFamiliesNewRoute: typeof TechnologyFamiliesNewRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  AuditIndexRoute: typeof AuditIndexRoute
  BusinessEnvironmentFactorsIndexRoute: typeof BusinessEnvironmentFactorsIndexRoute
  BusinessObjectivesIndexRoute: typeof BusinessObjectivesIndexRoute
  BusinessProcessesIndexRoute: typeof BusinessProcessesIndexRoute
  BusinessUnitsIndexRoute: typeof BusinessUnitsIndexRoute
  CapabilitiesIndexRoute: typeof CapabilitiesIndexRoute
  InformationIndexRoute: typeof InformationIndexRoute
  PhysicalProcessesIndexRoute: typeof PhysicalProcessesIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ServicesIndexRoute: typeof ServicesIndexRoute
  StakeholdersIndexRoute: typeof StakeholdersIndexRoute
  SuppliersIndexRoute: typeof SuppliersIndexRoute
  TagsIndexRoute: typeof TagsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TeamsIndexRoute: typeof TeamsIndexRoute
  TechnologiesIndexRoute: typeof TechnologiesIndexRoute
  TechnologyCapabilitiesIndexRoute: typeof TechnologyCapabilitiesIndexRoute
  TechnologyDomainsIndexRoute: typeof TechnologyDomainsIndexRoute
  TechnologyFamiliesIndexRoute: typeof TechnologyFamiliesIndexRoute
  MaturityFrameworksFrameworkIdRoute: typeof MaturityFrameworksFrameworkIdRouteWithChildren
  MaturityFrameworksNewRoute: typeof MaturityFrameworksNewRoute
  SettingsApiDocsGraphqlRoute: typeof SettingsApiDocsGraphqlRoute
  SettingsApiDocsRestRoute: typeof SettingsApiDocsRestRoute
  SuppliersSupplierIdEditRoute: typeof SuppliersSupplierIdEditRoute
  TagsTagIdEditRoute: typeof TagsTagIdEditRoute
  TagsCategoriesNewRoute: typeof TagsCategoriesNewRoute
  TechnologyFamiliesFamilyIdEditRoute: typeof TechnologyFamiliesFamilyIdEditRoute
  AdminBulkOperationsIndexRoute: typeof AdminBulkOperationsIndexRoute
  AdminModelPackageIndexRoute: typeof AdminModelPackageIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  MaturityComparisonIndexRoute: typeof MaturityComparisonIndexRoute
  MaturityFrameworksIndexRoute: typeof MaturityFrameworksIndexRoute
  SettingsApiDocsIndexRoute: typeof SettingsApiDocsIndexRoute
  SettingsApiKeysIndexRoute: typeof SettingsApiKeysIndexRoute
  SettingsPreferencesIndexRoute: typeof SettingsPreferencesIndexRoute
  TechnologiesRadarIndexRoute: typeof TechnologiesRadarIndexRoute
  TagsCategoriesCategoryIdEditRoute: typeof TagsCategoriesCategoryIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit/': {
      id: '/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-environment-factors/': {
      id: '/business-environment-factors/'
      path: '/business-environment-factors'
      fullPath: '/business-environment-factors/'
      preLoaderRoute: typeof BusinessEnvironmentFactorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-environment-factors/$businessEnvironmentFactorId': {
      id: '/business-environment-factors/$businessEnvironmentFactorId'
      path: '/business-environment-factors/$businessEnvironmentFactorId'
      fullPath: '/business-environment-factors/$businessEnvironmentFactorId'
      preLoaderRoute: typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-environment-factors/new': {
      id: '/business-environment-factors/new'
      path: '/business-environment-factors/new'
      fullPath: '/business-environment-factors/new'
      preLoaderRoute: typeof BusinessEnvironmentFactorsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-objectives/': {
      id: '/business-objectives/'
      path: '/business-objectives'
      fullPath: '/business-objectives/'
      preLoaderRoute: typeof BusinessObjectivesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-objectives/$businessObjectiveId': {
      id: '/business-objectives/$businessObjectiveId'
      path: '/business-objectives/$businessObjectiveId'
      fullPath: '/business-objectives/$businessObjectiveId'
      preLoaderRoute: typeof BusinessObjectivesBusinessObjectiveIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-objectives/new': {
      id: '/business-objectives/new'
      path: '/business-objectives/new'
      fullPath: '/business-objectives/new'
      preLoaderRoute: typeof BusinessObjectivesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-processes/': {
      id: '/business-processes/'
      path: '/business-processes'
      fullPath: '/business-processes/'
      preLoaderRoute: typeof BusinessProcessesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-processes/$businessProcessId': {
      id: '/business-processes/$businessProcessId'
      path: '/business-processes/$businessProcessId'
      fullPath: '/business-processes/$businessProcessId'
      preLoaderRoute: typeof BusinessProcessesBusinessProcessIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-processes/new': {
      id: '/business-processes/new'
      path: '/business-processes/new'
      fullPath: '/business-processes/new'
      preLoaderRoute: typeof BusinessProcessesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-units/': {
      id: '/business-units/'
      path: '/business-units'
      fullPath: '/business-units/'
      preLoaderRoute: typeof BusinessUnitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-units/$businessUnitId': {
      id: '/business-units/$businessUnitId'
      path: '/business-units/$businessUnitId'
      fullPath: '/business-units/$businessUnitId'
      preLoaderRoute: typeof BusinessUnitsBusinessUnitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-units/new': {
      id: '/business-units/new'
      path: '/business-units/new'
      fullPath: '/business-units/new'
      preLoaderRoute: typeof BusinessUnitsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capabilities/': {
      id: '/capabilities/'
      path: '/capabilities'
      fullPath: '/capabilities/'
      preLoaderRoute: typeof CapabilitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capabilities/$capabilityId': {
      id: '/capabilities/$capabilityId'
      path: '/capabilities/$capabilityId'
      fullPath: '/capabilities/$capabilityId'
      preLoaderRoute: typeof CapabilitiesCapabilityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capabilities/new': {
      id: '/capabilities/new'
      path: '/capabilities/new'
      fullPath: '/capabilities/new'
      preLoaderRoute: typeof CapabilitiesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/information/': {
      id: '/information/'
      path: '/information'
      fullPath: '/information/'
      preLoaderRoute: typeof InformationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/information/$dataDomainId': {
      id: '/information/$dataDomainId'
      path: '/information/$dataDomainId'
      fullPath: '/information/$dataDomainId'
      preLoaderRoute: typeof InformationDataDomainIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/information/new': {
      id: '/information/new'
      path: '/information/new'
      fullPath: '/information/new'
      preLoaderRoute: typeof InformationNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/physical-processes/': {
      id: '/physical-processes/'
      path: '/physical-processes'
      fullPath: '/physical-processes/'
      preLoaderRoute: typeof PhysicalProcessesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/physical-processes/$physicalProcessId': {
      id: '/physical-processes/$physicalProcessId'
      path: '/physical-processes/$physicalProcessId'
      fullPath: '/physical-processes/$physicalProcessId'
      preLoaderRoute: typeof PhysicalProcessesPhysicalProcessIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/physical-processes/new': {
      id: '/physical-processes/new'
      path: '/physical-processes/new'
      fullPath: '/physical-processes/new'
      preLoaderRoute: typeof PhysicalProcessesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/': {
      id: '/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof ServicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/$serviceId': {
      id: '/services/$serviceId'
      path: '/services/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof ServicesServiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/new': {
      id: '/services/new'
      path: '/services/new'
      fullPath: '/services/new'
      preLoaderRoute: typeof ServicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stakeholders/': {
      id: '/stakeholders/'
      path: '/stakeholders'
      fullPath: '/stakeholders/'
      preLoaderRoute: typeof StakeholdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stakeholders/$stakeholderId': {
      id: '/stakeholders/$stakeholderId'
      path: '/stakeholders/$stakeholderId'
      fullPath: '/stakeholders/$stakeholderId'
      preLoaderRoute: typeof StakeholdersStakeholderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stakeholders/new': {
      id: '/stakeholders/new'
      path: '/stakeholders/new'
      fullPath: '/stakeholders/new'
      preLoaderRoute: typeof StakeholdersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/': {
      id: '/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof SuppliersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/new': {
      id: '/suppliers/new'
      path: '/suppliers/new'
      fullPath: '/suppliers/new'
      preLoaderRoute: typeof SuppliersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/': {
      id: '/tags/'
      path: '/tags'
      fullPath: '/tags/'
      preLoaderRoute: typeof TagsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/new': {
      id: '/tags/new'
      path: '/tags/new'
      fullPath: '/tags/new'
      preLoaderRoute: typeof TagsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/': {
      id: '/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof TeamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/$teamId': {
      id: '/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof TeamsTeamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/new': {
      id: '/teams/new'
      path: '/teams/new'
      fullPath: '/teams/new'
      preLoaderRoute: typeof TeamsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technologies/': {
      id: '/technologies/'
      path: '/technologies'
      fullPath: '/technologies/'
      preLoaderRoute: typeof TechnologiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technologies/$technologyId': {
      id: '/technologies/$technologyId'
      path: '/technologies/$technologyId'
      fullPath: '/technologies/$technologyId'
      preLoaderRoute: typeof TechnologiesTechnologyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technologies/new': {
      id: '/technologies/new'
      path: '/technologies/new'
      fullPath: '/technologies/new'
      preLoaderRoute: typeof TechnologiesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-capabilities/': {
      id: '/technology-capabilities/'
      path: '/technology-capabilities'
      fullPath: '/technology-capabilities/'
      preLoaderRoute: typeof TechnologyCapabilitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-capabilities/$technologyCapabilityId': {
      id: '/technology-capabilities/$technologyCapabilityId'
      path: '/technology-capabilities/$technologyCapabilityId'
      fullPath: '/technology-capabilities/$technologyCapabilityId'
      preLoaderRoute: typeof TechnologyCapabilitiesTechnologyCapabilityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-capabilities/new': {
      id: '/technology-capabilities/new'
      path: '/technology-capabilities/new'
      fullPath: '/technology-capabilities/new'
      preLoaderRoute: typeof TechnologyCapabilitiesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-domains/': {
      id: '/technology-domains/'
      path: '/technology-domains'
      fullPath: '/technology-domains/'
      preLoaderRoute: typeof TechnologyDomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-domains/$technologyDomainId': {
      id: '/technology-domains/$technologyDomainId'
      path: '/technology-domains/$technologyDomainId'
      fullPath: '/technology-domains/$technologyDomainId'
      preLoaderRoute: typeof TechnologyDomainsTechnologyDomainIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-domains/new': {
      id: '/technology-domains/new'
      path: '/technology-domains/new'
      fullPath: '/technology-domains/new'
      preLoaderRoute: typeof TechnologyDomainsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-families/': {
      id: '/technology-families/'
      path: '/technology-families'
      fullPath: '/technology-families/'
      preLoaderRoute: typeof TechnologyFamiliesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-families/new': {
      id: '/technology-families/new'
      path: '/technology-families/new'
      fullPath: '/technology-families/new'
      preLoaderRoute: typeof TechnologyFamiliesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bulk-operations/': {
      id: '/admin/bulk-operations/'
      path: '/admin/bulk-operations'
      fullPath: '/admin/bulk-operations/'
      preLoaderRoute: typeof AdminBulkOperationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/model-package/': {
      id: '/admin/model-package/'
      path: '/admin/model-package'
      fullPath: '/admin/model-package/'
      preLoaderRoute: typeof AdminModelPackageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-environment-factors/$businessEnvironmentFactorId/edit': {
      id: '/business-environment-factors/$businessEnvironmentFactorId/edit'
      path: '/edit'
      fullPath: '/business-environment-factors/$businessEnvironmentFactorId/edit'
      preLoaderRoute: typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRouteImport
      parentRoute: typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute
    }
    '/business-objectives/$businessObjectiveId/edit': {
      id: '/business-objectives/$businessObjectiveId/edit'
      path: '/edit'
      fullPath: '/business-objectives/$businessObjectiveId/edit'
      preLoaderRoute: typeof BusinessObjectivesBusinessObjectiveIdEditRouteImport
      parentRoute: typeof BusinessObjectivesBusinessObjectiveIdRoute
    }
    '/business-processes/$businessProcessId/edit': {
      id: '/business-processes/$businessProcessId/edit'
      path: '/edit'
      fullPath: '/business-processes/$businessProcessId/edit'
      preLoaderRoute: typeof BusinessProcessesBusinessProcessIdEditRouteImport
      parentRoute: typeof BusinessProcessesBusinessProcessIdRoute
    }
    '/business-units/$businessUnitId/edit': {
      id: '/business-units/$businessUnitId/edit'
      path: '/edit'
      fullPath: '/business-units/$businessUnitId/edit'
      preLoaderRoute: typeof BusinessUnitsBusinessUnitIdEditRouteImport
      parentRoute: typeof BusinessUnitsBusinessUnitIdRoute
    }
    '/capabilities/$capabilityId/edit': {
      id: '/capabilities/$capabilityId/edit'
      path: '/edit'
      fullPath: '/capabilities/$capabilityId/edit'
      preLoaderRoute: typeof CapabilitiesCapabilityIdEditRouteImport
      parentRoute: typeof CapabilitiesCapabilityIdRoute
    }
    '/information/$dataDomainId/edit': {
      id: '/information/$dataDomainId/edit'
      path: '/edit'
      fullPath: '/information/$dataDomainId/edit'
      preLoaderRoute: typeof InformationDataDomainIdEditRouteImport
      parentRoute: typeof InformationDataDomainIdRoute
    }
    '/maturity/comparison/': {
      id: '/maturity/comparison/'
      path: '/maturity/comparison'
      fullPath: '/maturity/comparison/'
      preLoaderRoute: typeof MaturityComparisonIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maturity/frameworks/': {
      id: '/maturity/frameworks/'
      path: '/maturity/frameworks'
      fullPath: '/maturity/frameworks/'
      preLoaderRoute: typeof MaturityFrameworksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maturity/frameworks/$frameworkId': {
      id: '/maturity/frameworks/$frameworkId'
      path: '/maturity/frameworks/$frameworkId'
      fullPath: '/maturity/frameworks/$frameworkId'
      preLoaderRoute: typeof MaturityFrameworksFrameworkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maturity/frameworks/new': {
      id: '/maturity/frameworks/new'
      path: '/maturity/frameworks/new'
      fullPath: '/maturity/frameworks/new'
      preLoaderRoute: typeof MaturityFrameworksNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/physical-processes/$physicalProcessId/edit': {
      id: '/physical-processes/$physicalProcessId/edit'
      path: '/edit'
      fullPath: '/physical-processes/$physicalProcessId/edit'
      preLoaderRoute: typeof PhysicalProcessesPhysicalProcessIdEditRouteImport
      parentRoute: typeof PhysicalProcessesPhysicalProcessIdRoute
    }
    '/projects/$projectId/edit': {
      id: '/projects/$projectId/edit'
      path: '/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof ProjectsProjectIdEditRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/services/$serviceId/assessments': {
      id: '/services/$serviceId/assessments'
      path: '/assessments'
      fullPath: '/services/$serviceId/assessments'
      preLoaderRoute: typeof ServicesServiceIdAssessmentsRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/services/$serviceId/dependencies': {
      id: '/services/$serviceId/dependencies'
      path: '/dependencies'
      fullPath: '/services/$serviceId/dependencies'
      preLoaderRoute: typeof ServicesServiceIdDependenciesRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/services/$serviceId/diagrams': {
      id: '/services/$serviceId/diagrams'
      path: '/diagrams'
      fullPath: '/services/$serviceId/diagrams'
      preLoaderRoute: typeof ServicesServiceIdDiagramsRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/services/$serviceId/edit': {
      id: '/services/$serviceId/edit'
      path: '/edit'
      fullPath: '/services/$serviceId/edit'
      preLoaderRoute: typeof ServicesServiceIdEditRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/services/$serviceId/impact': {
      id: '/services/$serviceId/impact'
      path: '/impact'
      fullPath: '/services/$serviceId/impact'
      preLoaderRoute: typeof ServicesServiceIdImpactRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/settings/api-docs/': {
      id: '/settings/api-docs/'
      path: '/settings/api-docs'
      fullPath: '/settings/api-docs/'
      preLoaderRoute: typeof SettingsApiDocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-docs/graphql': {
      id: '/settings/api-docs/graphql'
      path: '/settings/api-docs/graphql'
      fullPath: '/settings/api-docs/graphql'
      preLoaderRoute: typeof SettingsApiDocsGraphqlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-docs/rest': {
      id: '/settings/api-docs/rest'
      path: '/settings/api-docs/rest'
      fullPath: '/settings/api-docs/rest'
      preLoaderRoute: typeof SettingsApiDocsRestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-keys/': {
      id: '/settings/api-keys/'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys/'
      preLoaderRoute: typeof SettingsApiKeysIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preferences/': {
      id: '/settings/preferences/'
      path: '/settings/preferences'
      fullPath: '/settings/preferences/'
      preLoaderRoute: typeof SettingsPreferencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stakeholders/$stakeholderId/edit': {
      id: '/stakeholders/$stakeholderId/edit'
      path: '/edit'
      fullPath: '/stakeholders/$stakeholderId/edit'
      preLoaderRoute: typeof StakeholdersStakeholderIdEditRouteImport
      parentRoute: typeof StakeholdersStakeholderIdRoute
    }
    '/suppliers/$supplierId/edit': {
      id: '/suppliers/$supplierId/edit'
      path: '/suppliers/$supplierId/edit'
      fullPath: '/suppliers/$supplierId/edit'
      preLoaderRoute: typeof SuppliersSupplierIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/$tagId/edit': {
      id: '/tags/$tagId/edit'
      path: '/tags/$tagId/edit'
      fullPath: '/tags/$tagId/edit'
      preLoaderRoute: typeof TagsTagIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/categories/new': {
      id: '/tags/categories/new'
      path: '/tags/categories/new'
      fullPath: '/tags/categories/new'
      preLoaderRoute: typeof TagsCategoriesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/$teamId/edit': {
      id: '/teams/$teamId/edit'
      path: '/edit'
      fullPath: '/teams/$teamId/edit'
      preLoaderRoute: typeof TeamsTeamIdEditRouteImport
      parentRoute: typeof TeamsTeamIdRoute
    }
    '/teams/$teamId/trends': {
      id: '/teams/$teamId/trends'
      path: '/trends'
      fullPath: '/teams/$teamId/trends'
      preLoaderRoute: typeof TeamsTeamIdTrendsRouteImport
      parentRoute: typeof TeamsTeamIdRoute
    }
    '/technologies/$technologyId/edit': {
      id: '/technologies/$technologyId/edit'
      path: '/edit'
      fullPath: '/technologies/$technologyId/edit'
      preLoaderRoute: typeof TechnologiesTechnologyIdEditRouteImport
      parentRoute: typeof TechnologiesTechnologyIdRoute
    }
    '/technologies/radar/': {
      id: '/technologies/radar/'
      path: '/technologies/radar'
      fullPath: '/technologies/radar/'
      preLoaderRoute: typeof TechnologiesRadarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technology-capabilities/$technologyCapabilityId/edit': {
      id: '/technology-capabilities/$technologyCapabilityId/edit'
      path: '/edit'
      fullPath: '/technology-capabilities/$technologyCapabilityId/edit'
      preLoaderRoute: typeof TechnologyCapabilitiesTechnologyCapabilityIdEditRouteImport
      parentRoute: typeof TechnologyCapabilitiesTechnologyCapabilityIdRoute
    }
    '/technology-domains/$technologyDomainId/edit': {
      id: '/technology-domains/$technologyDomainId/edit'
      path: '/edit'
      fullPath: '/technology-domains/$technologyDomainId/edit'
      preLoaderRoute: typeof TechnologyDomainsTechnologyDomainIdEditRouteImport
      parentRoute: typeof TechnologyDomainsTechnologyDomainIdRoute
    }
    '/technology-families/$familyId/edit': {
      id: '/technology-families/$familyId/edit'
      path: '/technology-families/$familyId/edit'
      fullPath: '/technology-families/$familyId/edit'
      preLoaderRoute: typeof TechnologyFamiliesFamilyIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maturity/frameworks/$frameworkId/edit': {
      id: '/maturity/frameworks/$frameworkId/edit'
      path: '/edit'
      fullPath: '/maturity/frameworks/$frameworkId/edit'
      preLoaderRoute: typeof MaturityFrameworksFrameworkIdEditRouteImport
      parentRoute: typeof MaturityFrameworksFrameworkIdRoute
    }
    '/services/$serviceId/assessments/$assessmentId': {
      id: '/services/$serviceId/assessments/$assessmentId'
      path: '/$assessmentId'
      fullPath: '/services/$serviceId/assessments/$assessmentId'
      preLoaderRoute: typeof ServicesServiceIdAssessmentsAssessmentIdRouteImport
      parentRoute: typeof ServicesServiceIdAssessmentsRoute
    }
    '/services/$serviceId/assessments/new': {
      id: '/services/$serviceId/assessments/new'
      path: '/new'
      fullPath: '/services/$serviceId/assessments/new'
      preLoaderRoute: typeof ServicesServiceIdAssessmentsNewRouteImport
      parentRoute: typeof ServicesServiceIdAssessmentsRoute
    }
    '/services/$serviceId/assessments/trends': {
      id: '/services/$serviceId/assessments/trends'
      path: '/trends'
      fullPath: '/services/$serviceId/assessments/trends'
      preLoaderRoute: typeof ServicesServiceIdAssessmentsTrendsRouteImport
      parentRoute: typeof ServicesServiceIdAssessmentsRoute
    }
    '/tags/categories/$categoryId/edit': {
      id: '/tags/categories/$categoryId/edit'
      path: '/tags/categories/$categoryId/edit'
      fullPath: '/tags/categories/$categoryId/edit'
      preLoaderRoute: typeof TagsCategoriesCategoryIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteChildren {
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute: typeof BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute
}

const BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteChildren: BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteChildren =
  {
    BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute:
      BusinessEnvironmentFactorsBusinessEnvironmentFactorIdEditRoute,
  }

const BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren =
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute._addFileChildren(
    BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteChildren,
  )

interface BusinessObjectivesBusinessObjectiveIdRouteChildren {
  BusinessObjectivesBusinessObjectiveIdEditRoute: typeof BusinessObjectivesBusinessObjectiveIdEditRoute
}

const BusinessObjectivesBusinessObjectiveIdRouteChildren: BusinessObjectivesBusinessObjectiveIdRouteChildren =
  {
    BusinessObjectivesBusinessObjectiveIdEditRoute:
      BusinessObjectivesBusinessObjectiveIdEditRoute,
  }

const BusinessObjectivesBusinessObjectiveIdRouteWithChildren =
  BusinessObjectivesBusinessObjectiveIdRoute._addFileChildren(
    BusinessObjectivesBusinessObjectiveIdRouteChildren,
  )

interface BusinessProcessesBusinessProcessIdRouteChildren {
  BusinessProcessesBusinessProcessIdEditRoute: typeof BusinessProcessesBusinessProcessIdEditRoute
}

const BusinessProcessesBusinessProcessIdRouteChildren: BusinessProcessesBusinessProcessIdRouteChildren =
  {
    BusinessProcessesBusinessProcessIdEditRoute:
      BusinessProcessesBusinessProcessIdEditRoute,
  }

const BusinessProcessesBusinessProcessIdRouteWithChildren =
  BusinessProcessesBusinessProcessIdRoute._addFileChildren(
    BusinessProcessesBusinessProcessIdRouteChildren,
  )

interface BusinessUnitsBusinessUnitIdRouteChildren {
  BusinessUnitsBusinessUnitIdEditRoute: typeof BusinessUnitsBusinessUnitIdEditRoute
}

const BusinessUnitsBusinessUnitIdRouteChildren: BusinessUnitsBusinessUnitIdRouteChildren =
  {
    BusinessUnitsBusinessUnitIdEditRoute: BusinessUnitsBusinessUnitIdEditRoute,
  }

const BusinessUnitsBusinessUnitIdRouteWithChildren =
  BusinessUnitsBusinessUnitIdRoute._addFileChildren(
    BusinessUnitsBusinessUnitIdRouteChildren,
  )

interface CapabilitiesCapabilityIdRouteChildren {
  CapabilitiesCapabilityIdEditRoute: typeof CapabilitiesCapabilityIdEditRoute
}

const CapabilitiesCapabilityIdRouteChildren: CapabilitiesCapabilityIdRouteChildren =
  {
    CapabilitiesCapabilityIdEditRoute: CapabilitiesCapabilityIdEditRoute,
  }

const CapabilitiesCapabilityIdRouteWithChildren =
  CapabilitiesCapabilityIdRoute._addFileChildren(
    CapabilitiesCapabilityIdRouteChildren,
  )

interface InformationDataDomainIdRouteChildren {
  InformationDataDomainIdEditRoute: typeof InformationDataDomainIdEditRoute
}

const InformationDataDomainIdRouteChildren: InformationDataDomainIdRouteChildren =
  {
    InformationDataDomainIdEditRoute: InformationDataDomainIdEditRoute,
  }

const InformationDataDomainIdRouteWithChildren =
  InformationDataDomainIdRoute._addFileChildren(
    InformationDataDomainIdRouteChildren,
  )

interface PhysicalProcessesPhysicalProcessIdRouteChildren {
  PhysicalProcessesPhysicalProcessIdEditRoute: typeof PhysicalProcessesPhysicalProcessIdEditRoute
}

const PhysicalProcessesPhysicalProcessIdRouteChildren: PhysicalProcessesPhysicalProcessIdRouteChildren =
  {
    PhysicalProcessesPhysicalProcessIdEditRoute:
      PhysicalProcessesPhysicalProcessIdEditRoute,
  }

const PhysicalProcessesPhysicalProcessIdRouteWithChildren =
  PhysicalProcessesPhysicalProcessIdRoute._addFileChildren(
    PhysicalProcessesPhysicalProcessIdRouteChildren,
  )

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdEditRoute: typeof ProjectsProjectIdEditRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdEditRoute: ProjectsProjectIdEditRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

interface ServicesServiceIdAssessmentsRouteChildren {
  ServicesServiceIdAssessmentsAssessmentIdRoute: typeof ServicesServiceIdAssessmentsAssessmentIdRoute
  ServicesServiceIdAssessmentsNewRoute: typeof ServicesServiceIdAssessmentsNewRoute
  ServicesServiceIdAssessmentsTrendsRoute: typeof ServicesServiceIdAssessmentsTrendsRoute
}

const ServicesServiceIdAssessmentsRouteChildren: ServicesServiceIdAssessmentsRouteChildren =
  {
    ServicesServiceIdAssessmentsAssessmentIdRoute:
      ServicesServiceIdAssessmentsAssessmentIdRoute,
    ServicesServiceIdAssessmentsNewRoute: ServicesServiceIdAssessmentsNewRoute,
    ServicesServiceIdAssessmentsTrendsRoute:
      ServicesServiceIdAssessmentsTrendsRoute,
  }

const ServicesServiceIdAssessmentsRouteWithChildren =
  ServicesServiceIdAssessmentsRoute._addFileChildren(
    ServicesServiceIdAssessmentsRouteChildren,
  )

interface ServicesServiceIdRouteChildren {
  ServicesServiceIdAssessmentsRoute: typeof ServicesServiceIdAssessmentsRouteWithChildren
  ServicesServiceIdDependenciesRoute: typeof ServicesServiceIdDependenciesRoute
  ServicesServiceIdDiagramsRoute: typeof ServicesServiceIdDiagramsRoute
  ServicesServiceIdEditRoute: typeof ServicesServiceIdEditRoute
  ServicesServiceIdImpactRoute: typeof ServicesServiceIdImpactRoute
}

const ServicesServiceIdRouteChildren: ServicesServiceIdRouteChildren = {
  ServicesServiceIdAssessmentsRoute:
    ServicesServiceIdAssessmentsRouteWithChildren,
  ServicesServiceIdDependenciesRoute: ServicesServiceIdDependenciesRoute,
  ServicesServiceIdDiagramsRoute: ServicesServiceIdDiagramsRoute,
  ServicesServiceIdEditRoute: ServicesServiceIdEditRoute,
  ServicesServiceIdImpactRoute: ServicesServiceIdImpactRoute,
}

const ServicesServiceIdRouteWithChildren =
  ServicesServiceIdRoute._addFileChildren(ServicesServiceIdRouteChildren)

interface StakeholdersStakeholderIdRouteChildren {
  StakeholdersStakeholderIdEditRoute: typeof StakeholdersStakeholderIdEditRoute
}

const StakeholdersStakeholderIdRouteChildren: StakeholdersStakeholderIdRouteChildren =
  {
    StakeholdersStakeholderIdEditRoute: StakeholdersStakeholderIdEditRoute,
  }

const StakeholdersStakeholderIdRouteWithChildren =
  StakeholdersStakeholderIdRoute._addFileChildren(
    StakeholdersStakeholderIdRouteChildren,
  )

interface TeamsTeamIdRouteChildren {
  TeamsTeamIdEditRoute: typeof TeamsTeamIdEditRoute
  TeamsTeamIdTrendsRoute: typeof TeamsTeamIdTrendsRoute
}

const TeamsTeamIdRouteChildren: TeamsTeamIdRouteChildren = {
  TeamsTeamIdEditRoute: TeamsTeamIdEditRoute,
  TeamsTeamIdTrendsRoute: TeamsTeamIdTrendsRoute,
}

const TeamsTeamIdRouteWithChildren = TeamsTeamIdRoute._addFileChildren(
  TeamsTeamIdRouteChildren,
)

interface TechnologiesTechnologyIdRouteChildren {
  TechnologiesTechnologyIdEditRoute: typeof TechnologiesTechnologyIdEditRoute
}

const TechnologiesTechnologyIdRouteChildren: TechnologiesTechnologyIdRouteChildren =
  {
    TechnologiesTechnologyIdEditRoute: TechnologiesTechnologyIdEditRoute,
  }

const TechnologiesTechnologyIdRouteWithChildren =
  TechnologiesTechnologyIdRoute._addFileChildren(
    TechnologiesTechnologyIdRouteChildren,
  )

interface TechnologyCapabilitiesTechnologyCapabilityIdRouteChildren {
  TechnologyCapabilitiesTechnologyCapabilityIdEditRoute: typeof TechnologyCapabilitiesTechnologyCapabilityIdEditRoute
}

const TechnologyCapabilitiesTechnologyCapabilityIdRouteChildren: TechnologyCapabilitiesTechnologyCapabilityIdRouteChildren =
  {
    TechnologyCapabilitiesTechnologyCapabilityIdEditRoute:
      TechnologyCapabilitiesTechnologyCapabilityIdEditRoute,
  }

const TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren =
  TechnologyCapabilitiesTechnologyCapabilityIdRoute._addFileChildren(
    TechnologyCapabilitiesTechnologyCapabilityIdRouteChildren,
  )

interface TechnologyDomainsTechnologyDomainIdRouteChildren {
  TechnologyDomainsTechnologyDomainIdEditRoute: typeof TechnologyDomainsTechnologyDomainIdEditRoute
}

const TechnologyDomainsTechnologyDomainIdRouteChildren: TechnologyDomainsTechnologyDomainIdRouteChildren =
  {
    TechnologyDomainsTechnologyDomainIdEditRoute:
      TechnologyDomainsTechnologyDomainIdEditRoute,
  }

const TechnologyDomainsTechnologyDomainIdRouteWithChildren =
  TechnologyDomainsTechnologyDomainIdRoute._addFileChildren(
    TechnologyDomainsTechnologyDomainIdRouteChildren,
  )

interface MaturityFrameworksFrameworkIdRouteChildren {
  MaturityFrameworksFrameworkIdEditRoute: typeof MaturityFrameworksFrameworkIdEditRoute
}

const MaturityFrameworksFrameworkIdRouteChildren: MaturityFrameworksFrameworkIdRouteChildren =
  {
    MaturityFrameworksFrameworkIdEditRoute:
      MaturityFrameworksFrameworkIdEditRoute,
  }

const MaturityFrameworksFrameworkIdRouteWithChildren =
  MaturityFrameworksFrameworkIdRoute._addFileChildren(
    MaturityFrameworksFrameworkIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRoute:
    BusinessEnvironmentFactorsBusinessEnvironmentFactorIdRouteWithChildren,
  BusinessEnvironmentFactorsNewRoute: BusinessEnvironmentFactorsNewRoute,
  BusinessObjectivesBusinessObjectiveIdRoute:
    BusinessObjectivesBusinessObjectiveIdRouteWithChildren,
  BusinessObjectivesNewRoute: BusinessObjectivesNewRoute,
  BusinessProcessesBusinessProcessIdRoute:
    BusinessProcessesBusinessProcessIdRouteWithChildren,
  BusinessProcessesNewRoute: BusinessProcessesNewRoute,
  BusinessUnitsBusinessUnitIdRoute:
    BusinessUnitsBusinessUnitIdRouteWithChildren,
  BusinessUnitsNewRoute: BusinessUnitsNewRoute,
  CapabilitiesCapabilityIdRoute: CapabilitiesCapabilityIdRouteWithChildren,
  CapabilitiesNewRoute: CapabilitiesNewRoute,
  InformationDataDomainIdRoute: InformationDataDomainIdRouteWithChildren,
  InformationNewRoute: InformationNewRoute,
  PhysicalProcessesPhysicalProcessIdRoute:
    PhysicalProcessesPhysicalProcessIdRouteWithChildren,
  PhysicalProcessesNewRoute: PhysicalProcessesNewRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ProjectsNewRoute: ProjectsNewRoute,
  ServicesServiceIdRoute: ServicesServiceIdRouteWithChildren,
  ServicesNewRoute: ServicesNewRoute,
  StakeholdersStakeholderIdRoute: StakeholdersStakeholderIdRouteWithChildren,
  StakeholdersNewRoute: StakeholdersNewRoute,
  SuppliersNewRoute: SuppliersNewRoute,
  TagsNewRoute: TagsNewRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TeamsTeamIdRoute: TeamsTeamIdRouteWithChildren,
  TeamsNewRoute: TeamsNewRoute,
  TechnologiesTechnologyIdRoute: TechnologiesTechnologyIdRouteWithChildren,
  TechnologiesNewRoute: TechnologiesNewRoute,
  TechnologyCapabilitiesTechnologyCapabilityIdRoute:
    TechnologyCapabilitiesTechnologyCapabilityIdRouteWithChildren,
  TechnologyCapabilitiesNewRoute: TechnologyCapabilitiesNewRoute,
  TechnologyDomainsTechnologyDomainIdRoute:
    TechnologyDomainsTechnologyDomainIdRouteWithChildren,
  TechnologyDomainsNewRoute: TechnologyDomainsNewRoute,
  TechnologyFamiliesNewRoute: TechnologyFamiliesNewRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  AuditIndexRoute: AuditIndexRoute,
  BusinessEnvironmentFactorsIndexRoute: BusinessEnvironmentFactorsIndexRoute,
  BusinessObjectivesIndexRoute: BusinessObjectivesIndexRoute,
  BusinessProcessesIndexRoute: BusinessProcessesIndexRoute,
  BusinessUnitsIndexRoute: BusinessUnitsIndexRoute,
  CapabilitiesIndexRoute: CapabilitiesIndexRoute,
  InformationIndexRoute: InformationIndexRoute,
  PhysicalProcessesIndexRoute: PhysicalProcessesIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ServicesIndexRoute: ServicesIndexRoute,
  StakeholdersIndexRoute: StakeholdersIndexRoute,
  SuppliersIndexRoute: SuppliersIndexRoute,
  TagsIndexRoute: TagsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TeamsIndexRoute: TeamsIndexRoute,
  TechnologiesIndexRoute: TechnologiesIndexRoute,
  TechnologyCapabilitiesIndexRoute: TechnologyCapabilitiesIndexRoute,
  TechnologyDomainsIndexRoute: TechnologyDomainsIndexRoute,
  TechnologyFamiliesIndexRoute: TechnologyFamiliesIndexRoute,
  MaturityFrameworksFrameworkIdRoute:
    MaturityFrameworksFrameworkIdRouteWithChildren,
  MaturityFrameworksNewRoute: MaturityFrameworksNewRoute,
  SettingsApiDocsGraphqlRoute: SettingsApiDocsGraphqlRoute,
  SettingsApiDocsRestRoute: SettingsApiDocsRestRoute,
  SuppliersSupplierIdEditRoute: SuppliersSupplierIdEditRoute,
  TagsTagIdEditRoute: TagsTagIdEditRoute,
  TagsCategoriesNewRoute: TagsCategoriesNewRoute,
  TechnologyFamiliesFamilyIdEditRoute: TechnologyFamiliesFamilyIdEditRoute,
  AdminBulkOperationsIndexRoute: AdminBulkOperationsIndexRoute,
  AdminModelPackageIndexRoute: AdminModelPackageIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  MaturityComparisonIndexRoute: MaturityComparisonIndexRoute,
  MaturityFrameworksIndexRoute: MaturityFrameworksIndexRoute,
  SettingsApiDocsIndexRoute: SettingsApiDocsIndexRoute,
  SettingsApiKeysIndexRoute: SettingsApiKeysIndexRoute,
  SettingsPreferencesIndexRoute: SettingsPreferencesIndexRoute,
  TechnologiesRadarIndexRoute: TechnologiesRadarIndexRoute,
  TagsCategoriesCategoryIdEditRoute: TagsCategoriesCategoryIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
